import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "./../servicios/auth.service";
import Logo from "./../recursos/logo_samsic.png";
import cebra from "./../recursos/cebra-magenta.png";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        El Campo es obligatorio
      </div>
    );
  }
};
const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        El email introducido no es valido
      </div>
    );
  }
};

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();

  const [usuario, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [debug, setDebug] = useState("");
  const navigate = useNavigate();
  const onChangeUsername = (e) => {
    const usuario = e.target.value;
    setUsername(usuario);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };
  useEffect(() => {
    document.title = "Samsic - Control Presencia";
  }, []);

  // Kiosko (Fully Kiosk): credenciales en la URL.
  //   Rellenar los cuadros:  /login?u=usuario&p=contrasena
  //   Ademas iniciar sesion solo:  /login?u=...&p=...&auto=1
  //   Tambien vale tras el # :  /login#u=...&p=...
  //   Alias: u|usuario|user  y  p|password|pass
  //   Para evitar autocorrectores del teclado, en base64:
  //     /login?k=BASE64("usuario:contrasena")     (opcional &auto=1)
  //   Y como ultimo recurso, basic-auth en la URL:
  //     https://usuario:contrasena@host/login     (no siempre lo deja leer el WebView)
  useEffect(() => {
    // Junta lo que haya en ?query y en #fragmento
    const hash = window.location.hash.replace(/^#\/?/, "");
    const hashQuery = hash.includes("?") ? hash.split("?")[1] : hash;
    const params = new URLSearchParams(window.location.search);
    const hParams = new URLSearchParams(hashQuery);
    const pick = (...keys) => {
      for (const k of keys) {
        const v = params.get(k) ?? hParams.get(k);
        if (v != null && v !== "") return v.trim();
      }
      return null;
    };

    let u = pick("u", "usuario", "user");
    let p = pick("p", "password", "pass");

    // Opcion base64: ?k=BASE64("usuario:contrasena")  -> sin palabras que el teclado autocorrija
    const k = pick("k", "kiosk", "cred");
    if (k && (!u || !p)) {
      try {
        const dec = decodeURIComponent(escape(window.atob(k)));
        const i = dec.indexOf(":");
        if (i > -1) {
          u = u || dec.slice(0, i).trim();
          p = p || dec.slice(i + 1).trim();
        }
      } catch (e) {
        console.warn("Kiosk: parametro k no es base64 valido", e);
      }
    }

    // Ultimo recurso: basic-auth en la URL (https://usuario:contrasena@host)
    // Muchos WebView lo quitan de location, pero cuando lo dejan, lo aprovechamos.
    if (!u || !p) {
      try {
        const parsed = new URL(window.location.href);
        if (parsed.username) u = u || decodeURIComponent(parsed.username);
        if (parsed.password) p = p || decodeURIComponent(parsed.password);
      } catch (e) {
        /* noop */
      }
    }

    console.log("Kiosk URL login -> usuario:", u ? JSON.stringify(u) : "(nada)");

    // Diagnostico en pantalla: anade ?debug=1 (o #debug=1) a la URL del kiosko
    if (params.get("debug") === "1" || hParams.get("debug") === "1") {
      setDebug(
        [
          "href: " + window.location.href,
          "search: " + JSON.stringify(window.location.search),
          "hash: " + JSON.stringify(window.location.hash),
          "usuario parseado: " + JSON.stringify(u) + "  (len " + (u ? u.length : 0) + ")",
          "password parseado: " + (p ? "(" + p.length + " chars)" : "(nada)"),
        ].join("\n"),
      );
    }

    // 1) Rellenar siempre lo que venga en la URL
    if (u) setUsername(u);
    if (p) setPassword(p);

    // 2) Iniciar sesion automaticamente solo si se pide con auto=1 (o login=1)
    const autoFlag = pick("auto", "login");
    const auto = autoFlag === "1" || autoFlag === "true";
    if (!auto || !u || !p) return;

    setLoading(true);
    setMessage("");
    AuthService.login(u, p).then(
      (r) => {
        setLoading(false);
        if (r && r.status) {
          navigate("/");
        } else {
          setMessage(
            (r && r.response && r.response.data && r.response.data.message) ||
              "No se pudo iniciar sesion automaticamente",
          );
        }
      },
      (error) => {
        setLoading(false);
        setMessage(
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            "No se pudo iniciar sesion automaticamente",
        );
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(usuario, password).then(
        // En caso de login correcto
        (r) => {
          console.log("login correcto", r);
          const resMessage =
            (r.response && r.response.data && r.response.data.message) ||
            r.message ||
            r.toString();

          setLoading(false);
          setMessage(resMessage);
          setUsername("");
          setPassword("");
          if (r.status) {
            navigate("/");
          }
          // window.location.reload();
        },
        // En caso de login incorrectoi
        (error) => {
          console.log("login incorrecto");
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
        },
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="col-xs-12 paginalogin margenboton">
      {/* <Link to={"/"} className="">
          Principal
        </Link> */}

      <div
        // style="background-color: rgba(0, 0, 0, 0.125);"
        className="card card-container"
      >
        <Typography align="center" variant="h4" component="h3" gutterBottom>
          Control Presencia
        </Typography>
        <img
          // src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          src={Logo}
          alt="profile-img"
          className="profile-img-card"
        />

        <Form onSubmit={handleLogin} ref={form}>
          <div className="form-group">
            <label htmlFor="usuario">Usuario</label>

            <Input
              type="text"
              className="form-control"
              name="usuario"
              value={usuario}
              onChange={onChangeUsername}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <Input
              type="password"
              className="form-control"
              name="password"
              value={password}
              onChange={onChangePassword}
              validations={[required]}
            />
          </div>

          <div className="form-group margenboton">
            <Button
              className="btn btn-primary btn-block"
              variant="contained"
              // disabled={loading}
              onClick={handleLogin}
            >
              <span>Login</span>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
            </Button>
            {/* <button
              className="btn btn-primary btn-block"
              disabled={loading}
              style={{
                backgroundColor: '#C0DB1A',
                borderColor: '#B3B8BB',
                color: '#ffffff',
              }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Login</span>
            </button> */}
          </div>
          {/* <a href="https://www.youtube.com/watch?v=WLkeANKdlSo"> */}

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
          {debug && (
            <pre
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                fontSize: 11,
                background: "#f4f6f8",
                border: "1px solid #cdd6df",
                borderRadius: 6,
                padding: 8,
                marginTop: 8,
              }}
            >
              {debug}
            </pre>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default Login;
